import React, {Component} from 'react';
import PropTypes from "prop-types";

/**
 * Main template for each section, using properties to pass in content
 *
 * @example
 * <SectionCard
 *   section={sectionType}
 *   title={title}
 *   footnote={footnote}
 *   exports={exports}
 *   summary={summary}
 *   controls={controls}
 *   legend={legend}
 *   content={chart}
 *   alternate={table}
 *   showAlternate={showTable}
 *  />
 */
export default class SectionCard extends Component {

  static propTypes = {
    section: PropTypes.string,
    title: PropTypes.node,
    summary: PropTypes.node,
    controls: PropTypes.node,
    content: PropTypes.node,
    alternate: PropTypes.node,
    legend: PropTypes.node,
    exports: PropTypes.node,
    footnote: PropTypes.node,
    showAlternate: PropTypes.bool
  };

  render() {
    return (
      <section className="container d-flex flex-wrap body-wrapper bg-white mt-5"
               aria-label={`${this.props.section} section`}>

        <div className="col-lg-4 order-sm-2 order-lg-1">

          <div>
            <div className="card mb-3 border-0 bg-gray-l3">
              <div className="card-body font-sm" id={`${this.props.section}-summary`}>
                {this.props.summary}
              </div>
            </div>
          </div>

          <div className="card mb-3">
            <div className="card-body">
              {this.props.controls}
            </div>
          </div>

          {this.props.legend && !this.props.showAlternate && (
            <div className="card mb-3">
              <div className="card-body">
                {this.props.legend}
              </div>
            </div>
          )}

          {this.props.exports && (
            <div className="card mb-3">
              <div className="card-body pb-1 pt-1">
                {this.props.exports}
              </div>
            </div>
          )}

        </div>

        <div className="col-lg-8 order-sm-1 order-lg-2 content">
          <h2 id={`${this.props.section}-title`}>
            {this.props.title}
          </h2>
          <div>
            {this.props.showAlternate ? this.props.alternate : this.props.content}
          </div>
          <div className="text-muted text-right pb-4 pr-2 pt-2 font-sm font-italic">
            {this.props.footnote}
          </div>
        </div>

      </section>
    )
  }
}
